import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var HotelIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M17 1a1 1 0 011 1 2 2 0 002 2 1 1 0 01.987 1.159c.003.014.005.028.006.043l.007.116V21h1a1 1 0 01.117 1.993L22 23H2a1 1 0 01-.117-1.993L2 21h1V5.318c0-.054.004-.107.013-.159A1 1 0 014 4a2 2 0 002-1.999 1 1 0 011-1h10zm-.874 2H7.874A4.007 4.007 0 015 5.875L5 21h4v-5a1 1 0 01-.117-1.993L9 14h6a1 1 0 01.117 1.993L15 16v5h4V5.874a4.007 4.007 0 01-2.874-2.873zM13 16h-2v5h2v-5zm3-6a1 1 0 01.117 1.993L16 12H8a1 1 0 01-.117-1.993L8 10h8zm0-4a1 1 0 01.117 1.993L16 8H8a1 1 0 01-.117-1.993L8 6h8z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
HotelIcon.isCarinaIcon = true;
export default HotelIcon;
